module.exports = __webpack_public_path__ + "img/advocate4.8730d174.png";